import {
  ACCOUNT,
  CLIENT_ACCOUNT,
  TEAMURL,
  TSINGHUA_API
} from '../baseURL'
import axios from '../config'

export default {

  //获取密保问题列表
  getSecurityList() {
    return axios.get(`${CLIENT_ACCOUNT}/user/problem`)
  },

  //注册
  register(payload) {
    return axios.post(`${CLIENT_ACCOUNT}/user/register`, payload)
  },

  //获取用户绑定的密保问题
  getUserSecurity(username) {
    return axios.get(`${CLIENT_ACCOUNT}/user/getProblem?Name=${username}`)
  },

  //验证用户密保
  verifyUserSecurity(payload) {
    const {
      username,
      answer
    } = payload
    return axios.get(`${CLIENT_ACCOUNT}/user/getAnswer?Name=${username}&Answer=${answer}`)
  },

  //重置密码
  setNewPassword(payload) {
    return axios.put(`${CLIENT_ACCOUNT}/user/putPassWord`, payload)
  },

  //获取上传凭证
  uploadToken() {
    return axios.get(`${TEAMURL}/qiniu/token?scope=lessonplan-img`)
  },

  //记录登录状态
  recordUserStatus(data) {
    return axios.post(`${TSINGHUA_API}/userStatus/record`, data)
  },

  //获取账号
  getClientByUser(name) {
    return axios.get(`${CLIENT_ACCOUNT}/user/search?Name=${name}`);
  },

  //发送短信验证码
  sendSms(phone) {
    return axios.post(`${ACCOUNT}/sms/sendDetail`, { Phone: phone });
  },

  //检查验证码是否正确
  checkcode(codeGuid, code) {
    return axios.get(`${ACCOUNT}/sms/checkcode?PK_CodeGuid=${codeGuid}&Code=${code}`);
  },
}